export type PointerCompletion = 'pointerup' | 'click' | 'change-or-close';

export class PerformanceFocusPolicy {
  private pointerId: number | null = null;
  private control: unknown;
  private completion: PointerCompletion = 'pointerup';

  constructor(private readonly restoreFocus: () => void) {}

  pointerDown(pointerId: number, control: unknown, completion: PointerCompletion = 'pointerup'): void {
    this.pointerId = pointerId;
    this.control = control;
    this.completion = completion;
  }

  isEditableTarget(target: unknown, nativeEditable: boolean): boolean {
    return nativeEditable && target !== this.control;
  }

  pointerUp(pointerId: number): boolean {
    if (pointerId !== this.pointerId || this.completion !== 'pointerup') return false;
    this.clearAndRestore();
    return true;
  }

  pointerCancel(pointerId: number): boolean {
    if (pointerId !== this.pointerId) return false;
    this.clearAndRestore();
    return true;
  }

  nativeClick(control: unknown): boolean {
    return this.completeNative(control, 'click');
  }

  nativeChangeOrClose(control: unknown): boolean {
    return this.completeNative(control, 'change-or-close');
  }

  isActiveControl(control: unknown): boolean {
    return this.pointerId !== null && control === this.control;
  }

  private completeNative(control: unknown, completion: PointerCompletion): boolean {
    if (control !== this.control || completion !== this.completion) return false;
    this.clearAndRestore();
    return true;
  }

  private clearAndRestore(): void {
    this.pointerId = null;
    this.control = undefined;
    this.completion = 'pointerup';
    this.restoreFocus();
  }
}
